import { FunnelSimple } from '@phosphor-icons/react'

import { CountryFlag, FormatNumber, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CountryRow = ({ country, columns, index, onClick, selected }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(country.country_code)
    }
  }

  return (
    <Styles.Container onClick={handleClick} selected={selected}>
      <Styles.IndexContainer>
        <Text type="bodyMRegular">{index}</Text>
      </Styles.IndexContainer>
      <td>
        <Styles.FlagAndNameContainer>
          <CountryFlag code={country.country_code} />
          <Text type="titleS">{country.country_name}</Text>
        </Styles.FlagAndNameContainer>
      </td>
      {columns.map(column => (
        <Styles.AmountsContainer key={column.field}>
          <Text type="bodyMRegular">
            <FormatNumber style={column.format}>{country[column.field]}</FormatNumber>
          </Text>
        </Styles.AmountsContainer>
      ))}
      <td>
        <FunnelSimple size={24} />
      </td>
    </Styles.Container>
  )
}

export default CountryRow
